<template>
	<v-container fluid>
		<div class="bottom-buttons-outer">
			<v-btn @click="backClick" color="success">
				<v-icon small>fa-reply</v-icon>&nbsp;{{$t('buttons.back')}}
			</v-btn>
			<v-btn @click="saveClick" color="success">
				<v-icon small>fa-save</v-icon>&nbsp;{{$t('buttons.save')}}
			</v-btn>
		</div>
		<v-layout row wrap>
			<v-flex lg8 md12 pa-1 sm12 xl6 xs12>
				<v-card>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12>
								<v-layout row wrap>
									<v-flex xs12>
										<Dropdown
											:ajax="true"
											:data="'subjects-suppliers'" :error="supplierServiceValidation.subject_id"
											:label="'* '+$t('fields.supplier')"
											v-model="supplierService.subject_id"></Dropdown>
									</v-flex>
									<v-flex xs12>
										<Dropdown
											:ajax="true"
											:data="'service-types'" :error="supplierServiceValidation.service_type_id"
											:label="'* '+$t('fields.serviceType')"
											v-model="supplierService.service_type_id"></Dropdown>
									</v-flex>
									<v-flex xs12>
										<InputField :error="supplierServiceValidation.service_name"
													:label="'* '+$t('fields.serviceName')"
													v-model="supplierService.service_name"></InputField>
									</v-flex>
									<v-flex xs12>
										<CurrencyField
											:error="supplierServiceValidation.price"
											:label="$t('fields.price') + ' (EUR)'"
											v-model="supplierService.price"></CurrencyField>
									</v-flex>
									<v-flex xs12>
										<CheckBox
											:label="$t('fields.active')"
											v-model="supplierService.active"></CheckBox>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import InputField from "./trinkets/InputField";
	import CheckBox from "./trinkets/CheckBox";
	import Dropdown from "./trinkets/Dropdown";
	import CurrencyField from "./trinkets/CurrencyField";

	export default {
		name: "SupplierService",
		components: {CheckBox, InputField, Dropdown, CurrencyField},
		props: {
			id: Number,
			action: String
		},
		data: function () {
			return {
				initialLoad: false,
				supplierService: {
					id: this.$route.params.id,
					service_name: '',
					subject_id: null,
					service_type_id: null,
					price: 0,
					active: true
				},
				supplierServiceValidation: {
					id: '',
					service_name: '',
					subject_id: '',
					service_type_id: '',
					price: '',
					active: ''
				},
				changesHappened: false
			}
		},
		watch: {
			supplierService: {
				handler: function () {
					if (this.initialLoad) {
						this.changesHappened = true;
					}
				},
				deep: true
			},
		},
		methods: {
			backClick() {
				this.$router.go(-1);
			},
			saveClick() {
				let success = true;

				if (this.supplierService.service_name.trim() == '') {
					success = false;
					this.supplierServiceValidation.service_name = this.$t('alerts.fieldError');
				} else {
					this.supplierServiceValidation.service_name = '';
				}

				if (this.supplierService.subject_id == null) {
					success = false;
					this.supplierServiceValidation.subject_id = this.$t('alerts.fieldError');
				} else {
					this.supplierServiceValidation.subject_id = '';
				}

				if (this.supplierService.service_type_id == null) {
					success = false;
					this.supplierServiceValidation.service_type_id = this.$t('alerts.fieldError');
				} else {
					this.supplierServiceValidation.service_type_id = '';
				}

				if (success) {
					let vm = this;
					let action = 'post';
					let addition = '';
					if (vm.supplierService.id != 0) {
						action = 'put';
						addition = '/' + vm.supplierService.id;
					}
					vm.$APICall(action, 'supplier-services' + addition, vm.supplierService, (data, success) => {
						if (success) {
							vm.changesHappened = false;
							if (vm.supplierService.id == 0) {
								vm.$notify(vm.$t('alerts.basicAdd'));
							} else {
								vm.$notify(vm.$t('alerts.basicUpdate'));
							}
							vm.$triggerReload();
							vm.backClick();
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					});
				}
			},
		},
		mounted() {
			if (!this.$myStore.state.loggedIn) {
				this.$router.replace('login');
			}
			this.$setSubMenu('Lists');
			if (this.supplierService.id != 0) {
				let vm = this;
				this.$APICall('get', 'supplier-services/' + this.supplierService.id, {}, (data, success) => {
					if (success) {
						let usableData = JSON.parse(JSON.stringify(data));
						vm.supplierService = usableData;
						vm.$myStore.commit('setBreadcrumbs', [
							{text: vm.$t('modules.supplierServices'), href: '/#/supplier-services', disabled: false},
							{
								text: vm.supplierService.service_name,
								href: '/#/supplier-services/' + vm.supplierService.id,
								disabled: true
							}
						]);
						vm.$nextTick(() => {
							vm.initialLoad = true;
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			} else {
				this.$myStore.commit('setBreadcrumbs', [
					{text: this.$t('modules.supplierServices'), href: '/#/supplier-services', disabled: false},
					{text: this.$t('modules.newSupplierService'), href: '/#/supplier-services/0', disabled: true}
				]);
				this.initialLoad = true;
			}
		},
		beforeRouteLeave(to, from, next) {
			if (this.changesHappened) {
				this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
					next(result);
				});
			} else {
				next(true);
			}
		}
	}
</script>

<style scoped>
</style>
